import React,{useState,useEffect} from 'react';
import DataTableX from '../../components/datatable/DataTableX';
import { Button } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';

//pdfMake.vfs = pdfFonts.pdfMake.vfs;
//window.JSZip = jsZip;




const  WorkOrderDatatable = (props) => {

   const [t] = useTranslation();      
   const tableName = t('workOrder.label.workOrders');
   const [hideEdit, setHideEdit ] = useState(false); 

   const clickHandler = (row) => {
            //row.target.id      
            if(typeof(row.target.id) !== 'undefined' && row.target.id != null){            
                props.modalCallback(true,row.target.id);  
            }
   
    };

   const columns = [       
            { name: "Id", data: "id", selector: "id", omit: true},
            { name: t('workOrder.label.workOrderNbr'), data: "nbr", sortable: true, selector: "nbr"},           
            { name: t('article.label.articleName'), data: "article.name", sortable: true, selector: "article.name", minWidth: '250px'},                 
            { name: t('workOrder.label.status'), data: "status", sortable: true, selector: "status"},    		            
            { name: t('workOrder.label.pcsOrd'), data: "qtyOrd", sortable: true, selector: "qtyOrd"},
            { name: t('workOrder.label.pcsOk'), data: "qtyOk", sortable: true, selector: "qtyOk"},
            { name: t('workOrder.label.pcsNok'), data: "qtyNok", sortable: true, selector: "qtyNok"},
            { name: t('workOrder.label.dueDate'), data: "dueDate", sortable: true, selector: "dueDate"},
            { name: t('workOrder.label.openDate'), data: "openDate", sortable: true, selector: "openDate"},
            { name: t('workOrder.label.closeDate'), data: "closeDate", sortable: true, selector: "closeDate"},
            { name: t('article.label.articleNumber'), data: "article.nbr", sortable: true, selector: "article.nbr"},    		       
            { name: t('workOrder.label.requestType'), data: "requestType", sortable: true, selector: "requestType" },
            { name: t('attendance.label.project'), data: "project.name", sortable: true, selector: "project.name"},
            { name: t('general.button.edit'),  omit: hideEdit, cell:(row) => row.id ? <Button className="btn-default"  onClick={clickHandler} id={row.id} name={row.name} >{t('general.button.edit')}</Button> : "",
            ignoreRowClick: true,
            allowOverflow: true,
            button: true
            
         }     		
        ];        


        
    const columnsData = [       
        { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('workOrder.label.workOrderNbr'), data: "nbr",  orderable: true, searchable: true, search: {value: '',regex: false}},          
        { name: t('article.label.articleName'), data: "article.name",  orderable: true, searchable: true, search: {value: '',regex: false}},   
        { name: t('workOrder.label.status'), data: "status",  orderable: true, searchable: true, search: {value: '',regex: false}},   
        { name: t('workOrder.label.pcsOrdered'), data: "qtyOrd",  orderable: true, searchable: true, search: {value: '',regex: false}},        
        { name: t('workOrder.label.pcsOk'), data: "qtyOk",  orderable: true, searchable: true, search: {value: '',regex: false}},        
        { name: t('workOrder.label.pcsNok'), data: "qtyNok",  orderable: true, searchable: true, search: {value: '',regex: false}},                
        { name: t('workOrder.label.dueDate'), data: "dueDate",  orderable: true, searchable: true, search: {value: '',regex: false}},                
        { name: t('workOrder.label.openDate'), data: "openDate",  orderable: true, searchable: true, search: {value: '',regex: false}},                
        { name: t('workOrder.label.closeDate'), data: "closeDate",  orderable: true, searchable: true, search: {value: '',regex: false}},                
        { name: t('article.label.articleNumber'), data: "article.nbr",  orderable: true, searchable: true, search: {value: '',regex: false}},        
        { name: t('workOrder.label.requestType'), data: "requestType",  orderable: true, searchable: true, search: {value: '',regex: false}},
        { name: t('attendance.label.name'), data: "project.name",  orderable: true, searchable: true, search: {value: '',regex: false}}
    ];        
    const url = RestService.getBaseURL()+"workOrder/getList";  
    const urlExcel = RestService.getBaseURL()+"workOrder/getExcelWorkOrder";          
 
    const handleCallback  = (id) => {
            props.parentCallback(id);                   
    };
  
     
    useEffect(() => {
       
        setHideEdit(props.hideEdit);
      }, [props.hideEdit]);
   
        return (
          
            <DataTableX
                url={url}  
                urlExcel={urlExcel}  
                tableName={tableName}
                columns={columns}   
                columnsData={columnsData}
                parentCallback={handleCallback}
                modalShow={props.modalShow}
                checkTime={props.checkTime}
            />
         
        );
   

 
};


export default WorkOrderDatatable;

